import {useState} from "react";
import Shell from "../../../../../components/specific/Shell.tsx";
import {User} from "../../../../../api/accessControl/User.ts";
import AddBusinessPopup from "./AddBusinessPopup.tsx";
import {BackendApi} from "../../../../../api/api.ts";
import {CreateBusinessApiPayload} from "../../../../../lib/businessRegistration.ts";
import {setCurrentBusinessId} from "../../../../../utils/OrgManagement.ts";
import {PrimaryButton} from "../../../../../components/general/PrimaryButton.tsx";
import {BuildingOfficeIcon, PlusIcon} from "@heroicons/react/24/outline";

export default function MyBusinessesPage({ currentUser }: { currentUser: User }) {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const api = new BackendApi(currentUser.getToken());

    const uniqueBusinesses = currentUser.access.filter(
        (access, index, self) => index === self.findIndex((a) => a.business_id === access.business_id)
    );

    const handleSwitchBusiness = (businessId: string) => {
        setCurrentBusinessId(businessId);
        window.location.href = '/';
    };

    const createNewBusiness = async (data: CreateBusinessApiPayload) => {
        await api.Entrepreneur__createBusiness(data);
    };

    return (
        <>
            <Shell currentUser={currentUser} isLoading={false} title={
                <div className="flex items-center justify-between">
                    <h1 className="weight-600 text-3xl">Mijn bedrijven</h1>
                    <PrimaryButton
                        title="Nieuw bedrijf"
                        icon={PlusIcon}
                        onClick={() => setIsModalOpen(true)}
                    />
                </div>
            }>
                <div className="mx-auto max-w-2xl">
                    <div className="space-y-3">
                        {uniqueBusinesses.map((item) => (
                            <button
                                key={item.business_id}
                                onClick={() => handleSwitchBusiness(item.business_id)}
                                className="w-full bg-gray-100 rounded-lg p-4 hover:bg-gray-200 transition-colors text-left flex items-center gap-4"
                            >
                                <div className="bg-indigo-100 rounded-full p-3 flex-shrink-0">
                                    <BuildingOfficeIcon className="w-6 h-6 text-indigo-600"/>
                                </div>
                                <h2 className="text-base font-semibold text-gray-900">
                                    {item.business_name || "Onbekend bedrijf"}
                                </h2>
                            </button>
                        ))}
                    </div>
                </div>
            </Shell>

            <AddBusinessPopup
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onSuccess={() => {
                    setIsModalOpen(false);
                    window.location.reload();
                }}
                createNewBusiness={createNewBusiness}
            />
        </>
    );
}
